import React, { Component } from 'react';
import './../../assets/css/App.css';
import { Tabs, Tab } from 'react-bootstrap';
import PackageCheckInTimeByOperatorView from './packageCheckInTimeByOperator';
import ErrorPackageCheckInsByWorker from './errorPackageCheckInsByWorker';

class TabPanelView extends Component {
    state = {
        selectedTabKey: 1
    }

    constructor() {
        super();
    }

    handleTabSelect = (key) => {
        this.setState({
            selectedTabKey : key
        });
    };

    render() {
        return (
            <div>
                <Tabs activeKey={this.state.selectedTabKey} onSelect={this.handleTabSelect} id="controlled-tab-example">
                    <Tab eventKey={1} title="Package Check-Ins By Operator">
                        <PackageCheckInTimeByOperatorView/>
                    </Tab>
                    <Tab eventKey={2} title="Package Check-In Errors By Operator">
                        <ErrorPackageCheckInsByWorker/>
                    </Tab>
                </Tabs>
            </div>
        );
    }
}

export default TabPanelView;
